import Loader from 'components/Loader';
import classnames from 'classnames';

export default function ActionButton({
  enabled = true,
  onClick = () => {},
  loading = false,
  label = '',
  classNames,
  type,
  roundedClass = 'rounded-sm',
  height = 48,
} = {}) {
  const clNames = classnames(
    'button is-flex is-align-items-centered ',
    'm-0 p-0',
    'has-background-green',
    { 'is-enabled': enabled },
    { 'is-disabled': !enabled },
    { [roundedClass]: !!roundedClass },
    { [classNames]: !!classNames }
  );
  return (
    <button
      type={type}
      style={{ height, width: '100%' }}
      className={clNames}
      onClick={!enabled ? () => {} : onClick}
    >
      {loading ? <Loader size={18} spacing="mx-button-loader" /> : <>{label}</>}
    </button>
  );
}
